module.exports = __webpack_public_path__ + "static/media/puzzleClue2.799aad46.png";